import type { Action } from 'state/actions';

import type { EmailServiceActiveState, EmailServiceState } from '.';
import { initialEmailServiceState } from '.';
import * as actionTypes from './emailService.actionTypes';

const defaultValueForActiveState: EmailServiceActiveState = {
  status: 'ACTIVE',
  recipient: 'Me',
  documents: [],
  subject: '',
  sendStatus: 'NOT_YET_SENT',
  warnings: [],
  errors: [],
  preview: {
    emails: [],
    errors: [],
    isLoading: true,
  },
};

// TODO: Unit test
export function emailServiceReducer(
  state: EmailServiceState = initialEmailServiceState,
  action: Action,
): EmailServiceState {
  switch (action.type) {
    case actionTypes.EMAIL_SERVICE_MODAL_OPENED:
      return { ...state, ...defaultValueForActiveState };
    case 'BLOTTER_PANEL_ITEM_RESET':
    case actionTypes.EMAIL_SERVICE_MODAL_CLOSED:
      return { ...initialEmailServiceState };
    case actionTypes.EMAIL_SERVICE_RECIPIENT_CHANGED:
      return state.status === 'ACTIVE'
        ? { ...state, recipient: action.value, preview: { ...defaultValueForActiveState.preview, isLoading: true } }
        : state;
    case actionTypes.EMAIL_SERVICE_DOCUMENTS_CHANGED:
      return state.status === 'ACTIVE' ? { ...state, documents: action.value } : state;
    case actionTypes.EMAIL_SERVICE_FORM_SUBMISSION_REQUESTED:
      return state.status === 'ACTIVE' ? { ...state, sendStatus: 'SENDING' } : state;
    case actionTypes.EMAIL_SERVICE_FORM_SUBMITTED:
      return state.status === 'ACTIVE'
        ? { ...state, sendStatus: 'SENT' as const, warnings: [...state.warnings, ...action.warnings] }
        : state;
    case actionTypes.EMAIL_SERVICE_FORM_SUBMISSION_FAILED:
      return state.status === 'ACTIVE'
        ? { ...state, sendStatus: 'SUBMISSION_FAILED' as const, errors: action.errors }
        : state;
    case actionTypes.EMAIL_SERVICE_PREVIEW_CONTENT_RECEIVED:
      return state.status === 'ACTIVE'
        ? { ...state, preview: { ...state.preview, ...action.value, isLoading: false } }
        : state;
    case actionTypes.EMAIL_SERVICE_PREVIEW_CONTENT_FAILED:
      return state.status === 'ACTIVE'
        ? { ...state, preview: { ...state.preview, isLoading: false, errors: action.value } }
        : state;
    default:
      return state;
  }
}
